import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

// Шторка — тот же диалог Radix, только выезжает от края экрана.
export const Sheet = (props: ComponentProps<typeof DialogPrimitive.Root>) => (
  <DialogPrimitive.Root data-slot="sheet" {...props} />
);
